/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type MediaDeviceKind =
  (typeof MediaDeviceKind)[keyof typeof MediaDeviceKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaDeviceKind = {
  audioinput: 'audioinput',
  videoinput: 'videoinput',
  audiooutput: 'audiooutput',
} as const;
